$(function(){
  $('div.readmore').append('<a href="#" id="show-more" class="show-more-less-link btn btn--small">Show More &#9660;</a><a href="#" id="show-less" class="show-more-less-link btn btn--small" style="display: none;">Show Less &#9650;</a>');

  $('a#show-more').click(function(evt){

    evt.preventDefault();
    // console.log('show more');
  
    let contentHeight = 0;
    $('div.readmore .rm-content').children().each(function() {
      contentHeight += $(this).height();
    });
  
    contentHeight += 120;
    
    $('div.readmore .rm-content').animate({
      height: contentHeight
    }, 300);
    
    $('div.readmore .rm-content').removeClass('collapsed');
  
    // $('div.readmore .rm-content').css('height', 'auto');
  
    $(this).hide();
    $('a#show-less').show();
  
  });

  $('a#show-less').click(function(evt){
    evt.preventDefault();
    $('div.readmore .rm-content').animate({
      height: '8rem'
    }, 300);
    
    $('div.readmore .rm-content').addClass('collapsed');
    
    $(this).hide();
    $('a#show-more').show();
  
  });
});